import { UUID } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { LIST_ASSETS_BY_STATE_QUERY_KEY } from './useFetchAssetsByState';
import { ASSET_STATE_COUNTS_QUERY_KEY } from './useGetAssetStateCounts';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from '@/hooks/api/folders/useFetchFolderContents';

export const useReprocessAsset = ({ onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}) => {
  const { getTenantId } = useTenants();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ['reprocessAsset'],
    mutationFn: (assetId: UUID) => api.assets.reprocessAsset(getTenantId(), assetId),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [GET_ASSET_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [LIST_FOLDER_CONTENTS_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [LIST_ASSETS_BY_STATE_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [ASSET_STATE_COUNTS_QUERY_KEY], exact: false });
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
  });

  return {
    reprocessAsset: mutate,
    reprocessAssetAsync: mutateAsync,
    isPending,
  };
};
